import { SLICE_DISTRICT } from '../config';

/** The time on the city's own clock (the HUD's), never the viewer's zone: "8:00 PM".
    Moved out of stageScreen (2026-10-29) so the stage's NEXT SHOW sign says it the same way.
    `zone: true` adds the zone's short name ("8:00 PM PDT"; PST in winter, from the
    calendar, never hardcoded): the city is Oakland, on West Coast time, and a visitor
    anywhere else has to know that to come back at the right moment (Khari, 2026-10-29). */
export function cityTime(ms, { zone = false } = {}) {
  const opts = { hour: 'numeric', minute: '2-digit', ...(zone ? { timeZoneName: 'short' } : {}) };
  try { return new Intl.DateTimeFormat('en-US', { ...opts, timeZone: SLICE_DISTRICT.timezone || 'America/Los_Angeles' }).format(new Date(ms)); }
  catch { return new Intl.DateTimeFormat('en-US', opts).format(new Date(ms)); }
}
